import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import FormatUtils from '@/utils/format_utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'StaffComponent',
  props: {
    title: { type: String, required: true },
    lastUpdate: { type: null, required: true },
    state: { type: String, required: false },
    supportingText: { type: String, required: false }
  },
  emits: ["change-page"],
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;



const state = computed(() => props.state ?? 'default');

function getState() {
  return `${state.value}`;
}


const __returned__ = { props, state, getState, get FormatUtils() { return FormatUtils } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})